

























export default {
  name: "BaseMediaButton",
  props: {
    selected: Boolean,
    deletable: Boolean,
    isPlug: Boolean,
  },
  methods: {
    handleClick(event: MouseEvent) {
      this.$emit("click", event);
    },
    handleDelete() {
      this.$emit("delete");
    },
  },
};
